import { apiCall } from '../../services/apiUtil';

export const teammatesApi = {
  getTeammates: (page = 1, limit = 50) =>
    apiCall(`/teammates?page=${page}&limit=${limit}`),

  getPendingRequests: () =>
    apiCall('/teammates/requests/pending'),

  getSentRequests: () =>
    apiCall('/teammates/requests/sent'),

  getStatus: (userId) =>
    apiCall(`/teammates/status/${userId}`),

  sendRequest: async (receiverId) => {
    try {
      return await apiCall('/teammates/request', {
        method: 'POST',
        body: JSON.stringify({ receiverId }),
      });
    } catch (err) {
      // 409 = request already exists, treat as success (already pending)
      if (err.status === 409) return { conflict: true };
      throw err;
    }
  },

  acceptRequest: (id) =>
    apiCall(`/teammates/request/${id}/accept`, { method: 'POST' }),

  declineRequest: (id) =>
    apiCall(`/teammates/request/${id}/decline`, { method: 'POST' }),

  cancelRequest: (id) =>
    apiCall(`/teammates/request/${id}`, { method: 'DELETE' }),

  removeTeammate: (userId) =>
    apiCall(`/teammates/${userId}`, { method: 'DELETE' }),
};
